
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import "../style/App.css";
import "../style/Home.css";
import "../style/ReactBootstrapOverride.css";

// className="gradient-aboutus"

const AboutUsOurValues = () => {

    return (
        <Container fluid style={ 
            { background: "linear-gradient(to top right, #e30a13, #e30a13, #e30a13, #e30a13, #f18286)"  }}>

            <Row>
                <Col md={{ span: 4, offset: 4 }}>
                    <h1 className='col-white' style={{textAlign: "center"}}>
                        OUR VALUES
                    </h1>
                </Col>
            </Row>
            

      <Row className='px-5'>
        <Col md={4} className='px-4'>
            <Row>
                <h1 className='col-white' style={{textAlign: "center"}}>01.</h1>
            </Row>
            <Row>
                <h4 className='col-white'>QUALITY</h4>
            </Row>    
            <Row>
                <p className='col-white'>We are committed to the pursuit of excellence in our surgical skills building system, service delivery and feedback process.</p>
            </Row>    
            
        </Col>
        <Col md={4} className='px-4'>
            <Row>
                <h1 className='col-white' style={{textAlign: "center"}}>02.</h1>
            </Row>
            <Row>
                <h4 className='col-white'>INNOVATION</h4>
            </Row>    
            <Row>
                <p className='col-white'>We understand the surgical training paradigm and strive to improve this for trainers, trainees and patients.</p>
            </Row>    
            
        </Col>
        <Col md={4} className='px-4'>
            <Row>
                <h1 className='col-white' style={{textAlign: "center"}}>03.</h1>
            </Row>
            <Row>
                <h4 className='col-white'>LEADERSHIP</h4>
            </Row>    
            <Row>
                <p className='col-white'>We are creating a philosophy of continued review, refinement and innovation to address challenges in modern surgical training.</p>
            </Row>    
            
        </Col>
    </Row>
        </Container>
    );
}

export default AboutUsOurValues;